var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-create-title-box"},[_c('div',{staticClass:"title-row"},[_c('h2',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"title-actions"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }